import React from 'react';
import _classes from './About.scss';
import { useNavigate } from "react-router-dom";

const About = () => {
    const navigate = useNavigate();
    return <div className='about fade-in-block'>

        <div className='container'>
            <div className='row'>
               
                <div className='col-12'>
                    <div className='me'></div>
                    <h3>About me</h3>
                    <p>
                        I am a Senior Accredited Psychotherapist with the British Association for Counselling and Psychotherapy (<a className='link' href="https://www.bacp.co.uk/therapists/396930/isobel-brooks/">BACP</a>). I am also registered with the British Psychoanalytic Council (<a className='link' href="https://www.bpc.org.uk/information-support/find-a-therapist-or-clinic/48030/">BPC</a>). I abide by the ethical frameworks of both associations.
                    </p>
                    <p>
                    I hold the following qualifications:
                    </p>
                    <p>
                        <bullet is="x3d">&bull; MSc in Psychodynamic Counselling and Psychotherapy</bullet>
                        <bullet is="x3d">&bull; BSc (hons) degree in Psychology</bullet>
                        <bullet is="x3d">&bull; Diploma in Counselling</bullet>
                        <bullet is="x3d">&bull; Certificate in Counselling</bullet>
                    </p>

                    <p>
                        I have been running my own private practice on a full time basis for several years. I have extensive experience working with clients who present with a wide range of issues. These include anxiety, depression, low self-esteem, trauma, abuse, relationship difficulties, bereavement, stress, loneliness and eating disorders.
                    </p>
                    <p>
                        Before we agree to work together in an open-ended way, I want to ensure that you will benefit from psychotherapy and that I am the right therapist for you. Our first session will therefore be an initial assessment. This is an introductory session where we will explore your reasons for seeking therapy and decide if therapy with me would suit you. It also gives me the opportunity to ensure my skill set is suitable for you and that I feel confident that I can meet your needs. 
                    </p>
                    <p>
                        If we decide that an alternative type of therapy would be a better fit, I can help you to find someone suitable to work with you.
                    </p>
                    <p>
                        If you have any further questions, please look at my <span className='link' onClick={() => navigate('/faq') }>FAQ</span> page
                    </p>
                </div> 
            </div>
        </div>
    </div>
}

export { About }
